interface HeightChange {
  timestamp: number;
  previousHeight: number;
  currentHeight: number;
  change: number;
}

export function checkDocumentHeightChanges(
  callback,
  interval = 100,
  stabilityTime = 300
) {
  //
  let lastHeight = document.documentElement.scrollHeight;
  let stabilityTimer;
  let mutationObserver;
  let stableTimeStart; // track when the height last changed

  function checkHeight() {
    const currentHeight = document.documentElement.scrollHeight;
    const now = Date.now();

    if (currentHeight !== lastHeight) {
      //
      // console.log({
      //   currentHeight,
      //   lastHeight,
      // });

      lastHeight = currentHeight;
      stableTimeStart = now; // reset stability start time
      clearTimeout(stabilityTimer);
      stabilityTimer = setTimeout(checkHeight, interval);
      //
    } else {
      if (stableTimeStart && now - stableTimeStart >= stabilityTime) {
        // height has been stable for stabilityTime
        clearTimeout(stabilityTimer);
        //
        if (mutationObserver) {
          mutationObserver.disconnect();
        }
        callback(lastHeight);
      } else {
        // height is the same but not stable yet
        clearTimeout(stabilityTimer);
        stabilityTimer = setTimeout(checkHeight, interval);
      }
    }
  }

  function startObserving() {
    mutationObserver = new MutationObserver(() => {
      stableTimeStart = Date.now(); // reset stability start time on any mutation
      clearTimeout(stabilityTimer);
      stabilityTimer = setTimeout(checkHeight, interval);
    });

    mutationObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true,
    });

    stableTimeStart = Date.now(); // initialize stability start time
    stabilityTimer = setTimeout(checkHeight, interval);
  }

  startObserving();
}
